var map = {
	"./a1.png": 530,
	"./centre-appel.png": 531,
	"./centre-appel2.png": 532,
	"./new.png": 533,
	"./s1.png": 534,
	"./s2.png": 535,
	"./s3.png": 536,
	"./s4.png": 537,
	"./s5.png": 538
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 292;